import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const baseStyles = {
    ...dialogCommon,
    buttonContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column-reverse',
        marginTop: 20
    },
    scrollViewContainer: {
        flexDirection: 'column',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    button: {
        margin: Theme.BU / 2,
        width: Device.isTabletOrWeb ? 'auto' : '100%'
    },
    titleContainer: {
        flexDirection: 'column',
        alignItems: 'center'
    },
    icon: {
        width: 23,
        height: 23,
        marginBottom: 10
    },
    line: {
        marginBottom: Theme.primaryMargin
    },
    descriptionBlock: {
        maxHeight: '15%'
    },
    higherDescriptionBlock: {
        maxHeight: '40%',
        marginBottom: 25
    },
    innerContainer: {},
    confirmButton: {
        marginTop: 20
    }
};

const landscapeStyles = StyleSheet.create({
    ...baseStyles,
    window: {
        ...baseStyles.window,
        paddingHorizontal: '20%'
    },
    buttonContainer: {
        ...baseStyles.buttonContainer,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    innerContainer: {
        justifyContent:'center'
    },
    icon: {
        ...baseStyles.icon,
        marginHorizontal: 15,
        marginTop: 6
    },
    managementDeviceButton: {
        ...baseStyles.button,
        width: 250
    },
    confirmButton: {
        ...baseStyles.button,
        width: 50
    },
    descriptionBlock: {
        maxHeight: '25%'
    },
    higherDescriptionBlock: {
        height: '50%'
    },
    titleContainer: {
        ...baseStyles.titleContainer,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start'
    }
});

if (Device.isTabletOrWeb) {
    baseStyles.buttonContainer.flexDirection = 'row';
    baseStyles.titleContainer = {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    };
    baseStyles.icon = {
        ...baseStyles.icon,
        marginHorizontal: 15
    };
}

export { landscapeStyles };
export default StyleSheet.create(baseStyles);
